import React from 'react'
import Link from 'gatsby-link'
import slugify from 'slugify'
import { slugifyOptions, homePageId } from '../../config'

import './footer.scss'

import LanguageSelector from '../LanguageSelector/language-selector'
import SubmitForm from '../SubmitForm/submit-form'

import Logo from '../../assets/logo'
import LogoSecondary from '../../assets/logo-secondary'
import FacebookIcon from '../../assets/icons/facebook-icon'
import InstagramIcon from '../../assets/icons/instagram-icon'
import TwitterIcon from '../../assets/icons/twitter-icon'
import YoutubeIcon from '../../assets/icons/youtube-icon'
import LinkedInIcon from '../../assets/icons/linkedin-icon'

class Footer extends React.Component {
  constructor(props) {
    super(props)
  }

  renderLink(item, index) {
    const url = item.id && item.id.indexOf(homePageId) === 0 ? `/${this.props.lang}` : `/${this.props.lang}/${slugify(item.title, slugifyOptions)}`
    return (
      <Link className="footer-page-link" key={`${slugify(item.title, slugifyOptions)}` + index} to={url}>
        {item.title}
      </Link>
    )
  }

  render() {
    const { localization, lang } = this.props
    const termsUrl = lang === 'fi' ? '/fi/tietosuojakaytanto' : '/en/terms-and-conditions'

    return (
      <footer className="footer-container" data-cy="footer">
        <div className="footer-top-row">
          <div className="footer-brand">
            <Link className="unstyled" to={ `/${lang}` }>
              <Logo/>
              <LogoSecondary/>
            </Link>
          </div>
          
        </div>
        <div className="footer-bottom-row">
          <div className="footer-column-left">
            <div className="footer-about">
              { localization('global.hiveDescription') }
            </div>
            <div className="footer-social">
              <a href="https://www.facebook.com/HiveHelsinki/" target="_blank" rel="noopener" className="footer-social-btn unstyled">
                <FacebookIcon/>
                <div className="footer-social-app">Facebook</div>
              </a>
              <a href="https://www.instagram.com/hivehelsinki/" target="_blank" rel="noopener" className="footer-social-btn unstyled">
                <InstagramIcon/>
                <div className="footer-social-app">Instagram</div>
              </a>
              <a href="https://www.linkedin.com/school/hive-helsinki/" target="_blank" rel="noopener" className="footer-social-btn unstyled">
                <LinkedInIcon/>
                <div className="footer-social-app">LinkedIn</div>
              </a>
              <a href="https://www.youtube.com/hivehelsinki" target="_blank" rel="noopener" className="footer-social-btn unstyled">
                <YoutubeIcon/>
                <div className="footer-social-app">YouTube</div>
              </a>
              <a href="https://twitter.com/HiveHelsinki" target="_blank" rel="noopener" className="footer-social-btn unstyled">
                <TwitterIcon/>
                <div className="footer-social-app">X</div>
              </a>
              
              
            </div>
          </div>
          <div className="footer-column-middle">
              <ul className="footer-pages">
                {this.props.navigation.map((item, i) => {
                  return (
                    <li key={i}>
                      {this.renderLink(item)}
                      
                      {item.subPages ? <ul className="footer-subpages">
                        {item.subPages.map((subItem, j) => {
                          return (
                            <li key={j}>{this.renderLink(subItem, j)}</li>
                          )
                        })}
                      </ul> : null}
                    </li>
                  )
                })}
              </ul>
            
          </div>
          <div className="footer-column-right">
            <div className="footer-signup-heading">
            { localization('global.newsLetter') }
            </div>
            <div className="footer-signup-body">
              { localization('global.newsLetterDescription') }
            </div>
            <SubmitForm content={this.props.mailingListForm} localization={localization}/>
            <div className="footer-terms-link">
              <Link to={termsUrl} >{ localization('global.termsAndConditions') }</Link>
            </div>
          </div>
        </div>
        <div className="footer-large-logo">
          <Logo/>
        </div>
      </footer>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/footer.js